<template>
           <div class="container" style="margin-top:20px;font-size:13px !important">
               <!-- subscription list   @click="ActivityMenu(data.unique_id,'chat')"-->
            <div v-for="data in list" :key="data.id"   class="row data-list" >
                <div class="col-sm-8 left" >
                    <div class="form-check">
                        <!-- <input type="checkbox" class="form-check-input" id="service-check"> -->
                        <label class="form-check-label" for="service-check">
                            <span class="service_status">
                            Service :  <span>{{ data.status=='Yes' ? 'Active' :'Not Active' }}</span>
                            </span>
                        </label>
                    </div>
                    <div class="services-list">  
                        <p class="date"><span>Date:</span> {{ formatDate(data.created_at, 'D-MMM-YYYY ') }}</p>
                        <p>
                            <span>Service:</span> {{data.company_name ? data.company_name : data.subscription_type}}
                        </p>  
                    </div>
                    
                    <div>
                        <a  v-if="data.status=='Yes'" href="javascript://" @click="Invoice(data.id )" class="gobtn">Invoice</a>
                         <a href="javascript://" @click="ActivityMenu(data.unique_id,'chat')" class="gobtn">More</a>
                           <a v-if="type=='BS' && data.status=='Yes'" href="javascript://"  @click="ActivityMenu(data.unique_id,'company_info')" class="gobtn entity_form_btn" style="position: relative;">Information sheet <span class="span_tooltip"><span class="arrow-top"></span>Please fill this information sheet to proceed further</span></a>
                    </div>
                </div>
                <div class="col-sm-4 right">
                    <ul>
                        <li><span class="chat">Chat : {{data.chat_unread_count}}</span></li>
                        <li><span class="files">Files:   {{data.files_count}}</span></li>
                        <li><span class="summanry_milestone">Summary: {{data.summary_count}}</span></li>
                    </ul>   
                </div>  
            </div>  
</div>
</template>
<script>
import BusinessSetup from '../../services/business_setup';
import Invoice from '../../services/invoice';
import ls from '../../services/ls';
import Pusher from 'pusher-js'
import moment from 'moment'
export default {
    name:'list-index',
    props:['type'],
    data(){
        return{
            // type:'BS',
            list:{},
            file_path:process.env.VUE_APP_URL,
            pusherKey:process.env.VUE_APP_PUSHER_KEY
        }
    },
    component:{
    },
    methods: {
         Menunav(to){
            this.$router.push({name:to});
            // window.location.href ='/workspace/'+to+'/'+activity_type
        },
          ActivityMenu(id,activity_type){
            var   type_url=this.$route.name;
            this.$router.push({name:'workspace',params:{type:type_url,activity_type:activity_type,id:id }})
        },
         ShowAlert(receiveData){
           if(ls.get('_u_unique')==receiveData.data.user_id){
               alert(receiveData.data.message);
               window.location.reload();
           }
        },
        formatDate(date,format){
             return moment(date).format(format);
        },
        Invoice(subscriptionId){
            Invoice.get({'subscription_id':subscriptionId,'from':'sub'})
                    .then(res=>{
                        var response = res.data;
                         const url = this.file_path + response.path + "/" + response.file;
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = '_blank';
                            link.type = 'application/octet-stream';
                            link.download=response.file
                            // link.setAttribute("download", response.file); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // link.remove();
                    })
                    .catch(err=>{console.log(err)});
        }
    },
    mounted(){
        BusinessSetup.get({type:this.type})
                .then(res=>{
                    this.list=res.data.list
                });
    },
    created(){
            this.pusher = new Pusher(this.pusherKey, {
                encrypted: true,
                cluster: 'ap2'
            })
            let that = this
            this.channel = this.pusher.subscribe('subscription')
            this.channel.bind('subscription_created', function (data) {
                that.$emit('subscription_created_user', data)
            })
            this.$on('subscription_created_user', function (receiveData) {
               this.ShowAlert(receiveData)
            })
    },

}
</script>